module.exports = __webpack_public_path__ + "static/img/logoKu.b10e596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoKu.png
// module id = etCD
// module chunks = 71